import {useState, useEffect} from '@wordpress/element';

export default function ServiceList({onApply, taxonomy, selectedTerms}) {
    const [terms, setTerms] = useState([]);
    const [selected, setSelected] = useState(selectedTerms);

    useEffect(() => {
        setSelected(selectedTerms);
    }, [selectedTerms]);


    useEffect(() => {
        if (!taxonomy) return; // важливо: чекаємо, поки taxonomy буде переданий

        fetch(pacers.ajaxUrl + '?action=get_services&taxonomy=' + taxonomy)
            .then(res => res.json())
            .then(res => {
                if (res.success) {
                    setTerms(res.data);
                }
            });
    }, [taxonomy]);

    // Отримати дітей певного parent
    const getChildren = (parentId) =>
        terms.filter(s => s.parent === parentId).map(s => s.id);


    // Обробка кліку по чекбоксу
    const toggle = (id, isParent) => {
        if (isParent) {
            const children = getChildren(id);

            // Якщо всі діти вибрані → зняти вибір
            if (children.every(c => selected.includes(c))) {
                setSelected(prev => prev.filter(x => !children.includes(x)));
            } else {
                // Інакше вибрати всіх дітей
                setSelected(prev => [...new Set([...prev, ...children])]);
            }
        } else {
            // Дитина
            setSelected(prev =>
                prev.includes(id)
                    ? prev.filter(x => x !== id)
                    : [...prev, id]
            );
        }
    };

    const parentTerms = terms.filter(s => s.parent === 0);

    return (
        <div className="pacers-services-list">
            {parentTerms.map(parent => {
                const children = terms.filter(s => s.parent === parent.id);
                const hasChildren = children.length > 0;

                return (
                    <React.Fragment key={parent.id}>
                        <div className="profile-links__title">
                            {hasChildren ? (
                                parent.name
                            ) : (
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={selected.includes(parent.id)}
                                        onChange={() => toggle(parent.id, false)}
                                    />
                                    {parent.name}
                                </label>
                            )}
                        </div>

                        {hasChildren && (
                            <ul className="profile-links__list">
                                {children.map(child => (
                                    <li key={child.id}>
                                        <label>
                                            <input
                                                type="checkbox"
                                                checked={selected.includes(child.id)}
                                                onChange={() => toggle(child.id, false)}
                                            />
                                            {child.name}
                                        </label>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </React.Fragment>

                )
            })}

            <button
                className="pacers-apply-btn btn btn-blue"
                onClick={() => onApply(selected)}
            >
                Apply
            </button>
        </div>
    );
}